import React, { useState } from "react";
import { Redirect } from "react-router";
import "./style.css";
import sucessImg from "../../../utils/assests/sucess.png";
// import { Box } from "@material-ui/core";
import Box from '@mui/material/Box';
import { Button } from "@material-ui/core";

function SucessPage() {
  const [click, setClick] = useState(false);

  const handleClick = () => {
    setClick(true);
  };

  return (
    <Box
      className="appPendigContainer newCard"
      component="div"
      textAlign="center"
    >
      {click ? <Redirect to="/dashboard" /> : ""}

      {/* <div>
        <Header pageName=" " />
      </div> */}

      <Box sx={{ textAlign: "center", pt: "70px", pb: "40px" }}>
        <img src={sucessImg} />
      </Box>

      <div style={{ textAlign: "center" }}>
        <h3 style={{ marginTop: "100px" }}>Thank you</h3>
      </div>

      <div
        style={{
          textAlign: "center",
          marginTop: 40,
          marginBottom: "30px",
        }}
      >
        <p style={{ padding: 0 }}>Your device has been sucessfully financed</p>
      </div>

      <div style={{ textAlign: "center", marginTop: "30px" }}>
        <p>Enjoy !!!</p>
      </div>

      <Box sx={{ mt: 15 }}>
        <Button
          variant="contained"
          color="secondary"
          className="redButton"
          onClick={handleClick}
        >
          Close
        </Button>
      </Box>
    </Box>
  );
}

export default SucessPage;
